export default __webpack_public_path__ + "static/media/brite.9afaadbb.svg";